import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import Icon from 'src/common/components/IconDS22';
import getClassName from 'src/common/utils/getClassName';
import s from './FormError.module.scss';

type FormErrorProps = {
  className?: string;
  error?: ReactNode;
  withIcon?: boolean;
};

const FormError: FC<FormErrorProps> = ({
  error = null,
  className,
  withIcon = false,
}) => (error ? (
  <div className={className || getClassName(s, 'root', classNames({ leftAligned: withIcon }))}>
    {withIcon && (
      <Icon
        className={s.icon}
        id="warning-filled"
        size="s"
      />
    )}
    {error}
  </div>
) : null);

export default FormError;
